import { UNITY_PRO_SERVICE_KEY } from "const/license";

export const createLicenseSlice = (set) => ({
  serviceStatus: null,
  serviceStatusSiteId: null,
  isUnityProSubscribed: false,
  setServiceStatus: (data, siteId = null) =>
    set({
      serviceStatus: data,
      serviceStatusSiteId: data ? siteId : null,
      // Site service status now has one Unity Pro entitlement.
      // Keep a normalized value so feature gates do not depend on the full
      // backend response shape.
      isUnityProSubscribed: data?.services?.[UNITY_PRO_SERVICE_KEY] === true,
    }),
});
